import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('USER_FRIENDS_SIDEBAR').plugin(axiosPlugin, {template: "array"});

let fetchUserFriendsAction = redux.fetchActionGet();

export const fetchUserFriendsSidebar = (userId, query = {}) => fetchUserFriendsAction(`/users/${userId}/friends?${queryString.stringify(query)}`);
export const resetUserFriendsSidebar = () => redux.actions.reset();

export const userFriendsSidebar = redux.reducer();